import { useFetch } from './fetch';
import { ContractDetailsRequest } from './types/contractDetailsRequest';
import { ContractDetailsResponse } from './types/contractDetailsResponse';

export const useContractDetails = (
  contractDetailsRequest: ContractDetailsRequest | null,
) => {
  const url = `${process.env.REACT_APP_BACKEND_API_URL}/contract/contractdetails/${contractDetailsRequest?.contractNumber}/${contractDetailsRequest?.contractPosition}`;

  const { isLoading, serverError, apiData } = useFetch('GET', `${url}`, {});

  return {
    isLoading,
    contractDetails: apiData as unknown as ContractDetailsResponse,
    serverError,
  };
};
